export default __webpack_public_path__ + "static/media/Quick-Lube.bddbc5f5.jpg";